import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const AlignField = styled.div`
    display: flex;
    flex-direction: column;
    width: 357px;
    min-height: 45px;
    margin: 0 0 24px 0;

    & svg {
        color: ${(props) => props.theme.orangeLink};
    }
`;

export const TitleReview = styled.div`
    font-size: ${theme.font.size14};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
`;

export const SubtitleReview = styled.div`
    font-size: ${theme.font.size16};
    letter-spacing: 0px;
    color: ${(props) => props.theme.black};

    & ul {
        list-style: none;
        padding: 0;

        & li {
            margin-bottom: 8px;
        }
    }
`;
